import { takeEvery, call, put } from 'redux-saga/effects';
import { dataRequest } from '../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksService from '../../../../services/TasksService';
import {
  sendRequest,
  requestInProcess,
  requestFinished
} from '../../../../common/reducers/taskRemoveForm';
import { sendRequestRefreshItem } from '../../../../../../common/reducers/_list/reducer';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../../users/common/reducers/states/authAccount';

function* taskRemoveFormSaga(reducerName, action) {
  try {
    yield put(requestInProcess(reducerName));
    const result = yield call(
      timeoutCall,
      TasksService.taskChangeStatus,
      action.payload,
      4
    );
    if (result.status === 200) {
      yield put(sendGetAuthAccountDataRequest());
      yield put(sendRequestRefreshItem(reducerName, action.payload));
      yield put(
        clientNoticesActions.addClientNotice({
          type: 'success',
          message: result.data.message
        })
      );
      yield put(
        dataRequest('tasksModule.collections.tasksCollection', action.payload)
      );
    } else if (result.status === 422) {
      yield put(
        clientNoticesActions.addClientNotice({
          type: 'danger',
          message: result.data[0].message
        })
      );
    }
    yield put(requestFinished(reducerName));
  } catch (error) {
    console.log(error);
  }
}

export default function createSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, taskRemoveFormSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/forms/sagas/taskRemoveFormSaga.js